
import * as React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress,
  Grid,
  Stack,
} from '@mui/material';
import api from "../../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  Autocomplete,
  TextField,
  IntegerField
} from '../../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { estados } from './estadosBrasileiros';


yup.setLocale(pt);


const DialogoAreasProtegidasEImpactadas = ({open, onClose,ano,dadosAreas,watchEmpresaId}) => {

  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);


  const schema = yup.object({
    unidadeFederativa: yup.number().positive().nullable().required()
      .label('Unidade Federativa'),
    areasProtegidas:yup.number().positive().nullable().nanable()
      .label('Áreas Protegidas (em ha)'),
    areasRegularizadas:yup.number().positive().nullable().nanable()
      .label('Áreas Regularizadas (em ha)'),
    areasConvenio:yup.number().positive().nullable().nanable()
      .label('Áreas Conservadas via Convênio (em ha)'),
    areasImpactadas:yup.number().positive().nullable().nanable()
      .label('Áreas Impactadas (em ha)'),
    fonteDaInformacao: yup.string().nullable()
      .label('Fonte da informação (ex: link internet)'),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const { handleSubmit, reset,
    formState: { isDirty, isSubmitting } } = useFormRef;

  const onSave = async (data) => {
    startLoading();

    try {
      if(data.id){
        await api.http.put(`/04/areas-protegidas-e-impactadas/empresa/${watchEmpresaId}/${data.id}`,{
          ...data,
          ano
        });
      }else{
        await api.http.post(`/04/areas-protegidas-e-impactadas/empresa/${watchEmpresaId}`,{
        ...data,
        ano
        });
      }
      stopLoading({ severity: 'success' });
      close(true);
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const close = (reload = false) => {
    onClose(reload);
    reset({
        unidadeFederativa:null,
        areasProtegidas:'',
        areasRegularizadas: '',
        areasConvenio: '',
        areasImpactadas:'',
        fonteDaInformacao:null
    });
  };


  React.useEffect(() => {
    reset(dadosAreas);
  },[dadosAreas]);

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle >Áreas Protegidas/Impactadas</DialogTitle>
      <DialogContent>
        <FormControl sx={{ my:1, mb: 2 }} fullWidth>
          <Autocomplete
            field="unidadeFederativa"
            useFormRef={useFormRef}
            options={estados}
            getOptionLabel={(sigla) => sigla.label}
            schema={schema} />
        </FormControl>
        <FormControl sx={{ my: 1 }} fullWidth>
          <IntegerField field="areasImpactadas"
                        schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl sx={{ my: 1 }} fullWidth>
          <IntegerField field="areasProtegidas"
                        schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl sx={{ my: 1 }} fullWidth>
          <IntegerField field="areasRegularizadas"
                        schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl sx={{ my: 1 }} fullWidth>
          <IntegerField field="areasConvenio"
                        schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField
            autoFocus
            fullWidth
            field="fonteDaInformacao"
            schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </DialogContent>
      <DialogActions>
        {loading > 0 &&
          <CircularProgress
            size={30}
            sx={{ 'position': 'absolute', 'left': 25, 'bottom': 12 }} />}
        <Button color="inherit" onClick={() => close()}>
          CANCELAR
        </Button>
        <Button color="primary"
          onClick={handleSubmit(onSave)}
          disabled={!isDirty || isSubmitting}>
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoAreasProtegidasEImpactadas;
